const __Colors = {
    petrol_dark: '#5B2E18',
    blue_orange: '#8A4A25',
    terminal_orange: '#C96935', // Akzent
    neon_orange: '#F08A45',
    amber_bright: '#FFB36B',
    terminal_light: '#FFD6A0',

    // terminal_light: '#8E9471',
    // terminal_light: '#A9AE86',
    hud_text: '#D8F6EE',
    terminal_white: '#FFE6C4',
    white_washed: '#E7EBD7',
    white: '#FFFFFF',

    black: '#050607',
    graphite_950: '#0A0C0E',
    graphite_900: '#101316',
    graphite_850: '#15191D',
    graphite_800: '#1B2025',
    graphite_750: '#20262C',
    graphite_700: '#252B31',
    graphite_650: '#2C333A',
    graphite_600: '#343B43',
    graphite_550: '#3E4650',
    graphite_500: '#4A535D',
    graphite_450: '#59636D',
    graphite_400: '#69737D',
    graphite_350: '#7A848E',
    graphite_300: '#8B949E',
    graphite_250: '#A0A8B0',
    graphite_200: '#B4BBC2',
    graphite_150: '#CBD1D6',
    graphite_100: '#DDE2E6',

    panel: 'rgba(21, 25, 29, 0.92)',
    panel_soft: 'rgba(27, 32, 37, 0.78)',
    panel_strong: 'rgba(10, 12, 14, 0.96)',
    panel_hover: 'rgba(52, 59, 67, 0.72)',
    panel_active: 'rgba(74, 83, 93, 0.64)',

    glass_dark: 'rgba(5, 6, 7, 0.72)',
    glass_medium: 'rgba(21, 25, 29, 0.62)',
    glass_light: 'rgba(221, 226, 230, 0.06)',

    border: 'rgba(180, 187, 194, 0.18)',
    border_soft: 'rgba(180, 187, 194, 0.10)',
    border_strong: 'rgba(221, 226, 230, 0.32)',
    border_accent: 'rgba(201, 105, 53, 0.42)',

    text_primary: '#E6EAED',
    text_secondary: '#B4BBC2',
    text_muted: '#7E8790',
    text_disabled: '#535C65',

    shadow_dark: 'rgba(0, 0, 0, 0.42)',
    shadow_soft: 'rgba(0, 0, 0, 0.24)',

    accent_soft: 'rgba(201, 105, 53, 0.18)',
    accent_medium: 'rgba(201, 105, 53, 0.32)',
    accent_strong: 'rgba(201, 105, 53, 0.56)',

    success: '#8E9471',
    success_soft: 'rgba(142, 148, 113, 0.18)',
    warning: '#FFB36B',
    warning_soft: 'rgba(255, 179, 107, 0.18)',
    danger: '#D36B6B',
    danger_soft: 'rgba(211, 107, 107, 0.18)',
}

const _Colors = {
    raw: __Colors,
    schemas: {
        primary: __Colors.neon_orange,
        secondary: __Colors.terminal_light,
        background: __Colors.terminal_orange,

        appBackground: __Colors.graphite_950,
        appBackgroundSoft: __Colors.graphite_900,

        surface: __Colors.panel,
        surfaceSoft: __Colors.panel_soft,
        surfaceStrong: __Colors.panel_strong,
        surfaceHover: __Colors.panel_hover,
        surfaceActive: __Colors.panel_active,

        border: __Colors.border,
        borderSoft: __Colors.border_soft,
        borderStrong: __Colors.border_strong,
        borderAccent: __Colors.border_accent,

        text: __Colors.text_primary,
        textSecondary: __Colors.text_secondary,
        textMuted: __Colors.text_muted,
        textDisabled: __Colors.text_disabled,

        accent: __Colors.terminal_orange,
        accentHover: __Colors.neon_orange,
        accentSoft: __Colors.accent_soft,
        accentMedium: __Colors.accent_medium,
        accentStrong: __Colors.accent_strong,

        highlight: __Colors.amber_bright,

        success: __Colors.success,
        warning: __Colors.warning,
        danger: __Colors.danger,
    }
}

export const Colors = {
    ..._Colors,
}